import React, { useEffect, useState } from "react";
import styles from "./CardCategoriesHeader.module.css";
//ui
import Grid from "@material-ui/core/Grid";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailCategoryRequest,
  fetchDeleteDetailCategoryRequest,
} from "redux/ActionCreators/CategoryActionCreators";
import {
  fetchDeleteDetailPromotionRequest,
  fetchDetailPromotionRequest,
} from "redux/ActionCreators/PromotionActionCreators";
import Title from "components/Title";

const CardCategoriesHeader = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const { searchProducts, categoryProducts, saleProducts } = match.params;

  const category = useSelector((state) => state.categories.detail);
  const promotion = useSelector((state) => state.promotions.detail);

  useEffect(() => {
    dispatch(fetchDeleteDetailCategoryRequest());
    dispatch(fetchDeleteDetailPromotionRequest());

    if (searchProducts) {
      return;
    } else if (categoryProducts) {
      dispatch(fetchDetailCategoryRequest(categoryProducts));
    } else {
      dispatch(fetchDetailPromotionRequest(saleProducts));
    }
  }, [searchProducts, categoryProducts, saleProducts]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12}>
        <div className={styles.title}>
          {category && <Title name={`${category.name} TAGS`} />}
          {searchProducts && <Title name={`${searchProducts} SEARCH`} />}
          {promotion && <Title name={`${promotion.name} SALES`} />}
        </div>
      </Grid>
    </Grid>
  );
};

export default CardCategoriesHeader;
